import { lazy } from 'react';
import { authRoles } from 'app/auth';

const ProductHistoryAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.productModerator,
	routes: [
		{
			path: '/apps/products/report-product-history',
			exact: true,
			component: lazy(() => import('./single/Data'))
		}
	]
};

export default ProductHistoryAppConfig;
